/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GroupRequestV1Dto } from '../models/GroupRequestV1Dto';
import type { RefreshTokenResponseV1Dto } from '../models/RefreshTokenResponseV1Dto';
import type { RefreshTokenV1Dto } from '../models/RefreshTokenV1Dto';
import type { UserV1Dto } from '../models/UserV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthService {
  /**
   * @param nextPage The page to redirect to after login
   * @returns void
   * @throws ApiError
   */
  public static entraAuthControllerV1LoginV1(nextPage?: string): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/auth/login',
      query: {
        nextPage: nextPage,
      },
      errors: {
        302: `will return redirect`,
      },
    });
  }
  /**
   * @returns UserV1Dto
   * @throws ApiError
   */
  public static entraAuthControllerV1GetProfileV1(): CancelablePromise<UserV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/auth/profile',
    });
  }
  /**
   * @param requestBody
   * @returns RefreshTokenResponseV1Dto Successful refresh
   * @throws ApiError
   */
  public static entraAuthControllerV1RefreshTokenV1(
    requestBody: RefreshTokenV1Dto,
  ): CancelablePromise<RefreshTokenResponseV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/auth/refresh-token',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Token refresh failed`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static entraAuthControllerV1SwitchGroupV1(
    requestBody: GroupRequestV1Dto,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/auth/switch-group',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @param customerId
   * @returns any All tokens are valid
   * @throws ApiError
   */
  public static entraAuthControllerV1GetTokenCheckV1(customerId: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/auth/token-check/{customerId}',
      path: {
        customerId: customerId,
      },
    });
  }
  /**
   * @param customerId
   * @returns any All tokens are valid
   * @throws ApiError
   */
  public static entraAuthControllerV1GetTokenCheck2V1(customerId: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/auth/customer-token-check/{customerId}',
      path: {
        customerId: customerId,
      },
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public static entraAuthCallbackControllerCallback(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/auth/callback',
    });
  }
}
